import { render } from "./AdminLaterWorkTemplates.vue?vue&type=template&id=2086e374"
import script from "./AdminLaterWorkTemplates.vue?vue&type=script&lang=js"
export * from "./AdminLaterWorkTemplates.vue?vue&type=script&lang=js"

import "./AdminLaterWorkTemplates.vue?vue&type=style&index=0&id=2086e374&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__